import React from "react";
var __jsx = React.createElement;
import { useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { SponsoFieldProperties } from '@uno/common-cms';
import Input from 'components/common/Input';
import SwitchInput from 'components/common/SwitchInput';
import { VariantAccordion, VariantAccordionSummary } from 'components/common/material-ui/custom-components';
import { AccordionDetailsColumn, InputContainer } from './SponsoField.style';
var displayFields = [SponsoFieldProperties.ctaLabel, SponsoFieldProperties.partnerUrl, SponsoFieldProperties.legalNotice, SponsoFieldProperties.partnerName];

var SponsoField = function SponsoField(_ref) {
  var formField = _ref.formField;
  var intl = useIntl();
  var switchInputName = "".concat(formField.name, ".").concat(SponsoFieldProperties.isSponsored);
  var switchInputValue = useWatch({
    name: switchInputName
  });
  var labelId = 'content-type.article.sponso';
  return __jsx(React.Fragment, null, __jsx(VariantAccordion, {
    expanded: switchInputValue === true
  }, __jsx(VariantAccordionSummary, null, __jsx(SwitchInput, {
    name: switchInputName,
    label: intl.formatMessage({
      id: "".concat(labelId, ".").concat(SponsoFieldProperties.isSponsored)
    }),
    defaultValue: formField.defaultValue.isSponsored
  })), __jsx(AccordionDetailsColumn, {
    "data-testid": "sponsoAccordionDetails"
  }, displayFields.map(function (property) {
    var _ref2;

    return __jsx(InputContainer, {
      key: property
    }, __jsx(Input, {
      name: "".concat(formField.name, ".").concat(property),
      label: intl.formatMessage({
        id: "".concat(labelId, ".").concat(property)
      }),
      defaultValue: (_ref2 = formField.defaultValue[property]) !== null && _ref2 !== void 0 ? _ref2 : ''
    }));
  }))));
};

export default SponsoField;